/**
 * login config interface for 3 user type
 */
export interface LoginConfig {
  userType: "clinician" | "admin" | "patient";
  title: string;

  userLabel: string;
  userIdFeedback: string;

  passwordLabel: string;
  forgetLinkText: string;
  forgotPasswordTooltip: string;
}

export const adminLoginConfig: LoginConfig = {
  userType: "admin",
  title: "Anmeldung Administrator*in",

  userLabel: "Admin-ID",
  userIdFeedback: "Bitte geben Sie Ihre Admin-ID ein.",

  passwordLabel: "Passwort",
  forgetLinkText: "Zugangsdaten vergessen?",
  forgotPasswordTooltip:
    "Wenn Sie Ihre Zugangsdaten vergessen haben, wenden Sie sich an sysdok@uniklinik-freiburg.de.",
};

export const clinicianLoginConfig: LoginConfig = {
  userType: "clinician",
  title: "Anmeldung Mitarbeitende",

  userLabel: "Mitarbeitenden-ID",
  userIdFeedback: "Bitte geben Sie Ihre Mitarbeitenden-ID ein.",

  passwordLabel: "Passwort",
  forgetLinkText: "Zugangsdaten vergessen?",
  forgotPasswordTooltip:
    "Wenn Sie Ihre Zugangsdaten vergessen haben, wenden Sie sich an Ihre*n Administrator*in.",
};

export const patientLoginConfig: LoginConfig = {
  userType: "patient",
  title: "Anmeldung Patient*in",

  userLabel: "SysDok-ID",
  userIdFeedback: "Bitte geben Sie Ihre SysDok-ID ein.",

  passwordLabel: "Geburtsdatum",
  forgetLinkText: "SysDok-ID vergessen?",
  forgotPasswordTooltip:
    "Wenn Sie Ihre Zugangsdaten vergessen haben, wenden Sie sich bitte an Ihre behandelnde Person.",
};
